<template>
    <div class="m-1">
        
        <CRow>
            <CCol col="2">
                <CButton
                    size="sm"
                    class="btn-class mb-1">
                    <CIcon name="cil-check-circle" /> Nuevo Cliente
                </CButton>
            </CCol>
            <CCol col="3">
                <CButton
                    v-show="!isLoadingEmpresas"
                    size="sm"
                    class="btn-class mb-1"
                    @click="getClientesVapp">
                    <CIcon name="cil-check-circle" /> Recargar Información
                </CButton>
            </CCol>
        </CRow>

        <div>
            <DatosGeneralClientes :datosGeneral="datosGeneral" :cargandoInfo="isLoadingEmpresas" :mostrarClientes="true" />
            
            <div>
                Ver Deshabilitados <CSwitch
                    :disabled="isLoadingEmpresas"
                    width="150px"
                    class="mx-1 align-middle mb-2" 
                    color="success" 
                    shape="pill"
                    variant="outline"
                    v-bind="{labelOn: 'Si',labelOff: 'No'}"
                    :checked="verDeshabilitados"
                    @update:checked="verDeshabilitados = !verDeshabilitados"
                />
            </div>
            <CRow>
                <CCol col="4">
                    
                    <vs-input
                        v-model="busquedaCliente"
                        border
                        @keyup="getClientesVapp"
                        placeholder="Buscar"
                    />
                </CCol>
                <CCol>
                    <div class="float-right">
                        <!--<vs-pagination v-model="page" :length="20" />-->
                        <vs-pagination
                            not-margin  
                            @input="prueba()"
                            v-model="paginaActual"
                            :length="obtenerLargoPaginacion(this.datosGeneral.total)"
                        />
                    </div>
                </CCol>
            </CRow>
        
            <CargandoInfo :mostrarCarga="isLoadingEmpresas" :mensajeInfo="'Obteniendo Información'" />
            <div v-show="!isLoadingEmpresas" style="max-height: 500px; overflow-y: auto;">
                <CRow class="mt-1" style="border-color: gray;" v-bind:key="cliente.infoCliente.idCliente" v-for="cliente in clientesVapp">
                    <CCol>
                        <CCard class="tarjetaGeneralInfo mt-1 mb-1" 
                            :class="(cliente.infoCliente.habilitado)?'cardHabil':'cardDeshab'"
                            @mouseover="cliente.acciones.focus = true" 
                            @mouseout="cliente.acciones.focus = false">
                            <CCardHeader>
                                <div class="card-header-actions" v-show="cliente.acciones.focus">
                                    <CLink class="card-header-action btn-minimize" @click="cliente.acciones.mostrarMas = !cliente.acciones.mostrarMas">
                                        <CIcon v-show="cliente.acciones.mostrarMas" :content="$options.freeSet.cilChevronTop" />
                                        <CIcon v-show="!cliente.acciones.mostrarMas" :content="$options.freeSet.cilChevronBottom" />
                                    </CLink>
                                </div>
                                <CRow>
                                    <CCol col="3">
                                        <!--<div><span class="font-weight-bold">Habilitado: </span>
                                            <CIcon style="color:green" name="cil-check-circle" v-show="cliente.infoCliente.habilitado"/>
                                            <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.infoCliente.habilitado" />
                                        </div>
                                        <div><span class="font-weight-bold">Rut: </span> {{(cliente.infoCliente.rutCliente != null) ? $utils.formatearRut(cliente.infoCliente.rutCliente) : 'Sin Rut'}}</div>
                                        
                                        <div class="infoDetalle"><span class="font-weight-bold">Nombre: </span><span
                                            :content="cliente.infoCliente.nombreCliente"                                            
                                            v-tippy="{ 
                                                placement: 'top',
                                                arrow: true, 
                                                arrowType: 'round', 
                                                animation:'fade',
                                                theme: 'google',
                                                followCursor : true,
                                            }">{{ cliente.infoCliente.nombreCliente }}</span>
                                        </div>
                                        -->
                                        <div class="infoDetalle">
                                            <span class="font-weight-bold">Grupo Vapp: </span> 
                                            <span 
                                            :content="cliente.infoCliente.nombreCliente"
                                            v-tippy="{ 
                                                placement: 'top',
                                                arrow: true, 
                                                arrowType: 'round', 
                                                animation:'fade',
                                                theme: 'google',
                                                followCursor : true,
                                            }">{{ cliente.infoCliente.grupoVapp }}</span>
                                        </div>
                                        <div class="infoDetalle"><span class="font-weight-bold">Rut: </span>{{ (cliente.infoCliente.rutCliente != null) ? $utils.formatearRut(cliente.infoCliente.rutCliente) : 'Sin Rut' }}</div>
                                        <div class="infoDetalle"><span class="font-weight-bold">Fecha Creacion: </span>{{ $utils.formatearFecha(cliente.infoCliente.fechaCreacionCliente) }}</div>
                                        
                                    </CCol>
                                    <CCol col="3">
                                        <div>
                                            <span class="font-weight-bold">Usuarios: </span> 
                                            <span
                                                content="Habilitados / Total"                                            
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }">
                                            {{ cliente.infoCliente.infoUsuarios.habilitados }}/{{ cliente.infoCliente.infoUsuarios.totalUsuarios }}</span>
                                        </div>
                                        <div>
                                            <span class="font-weight-bold">Apps: </span> 
                                                <span
                                                    content="Asignadas / Total"                                            
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }">
                                                {{ cliente.infoCliente.infoApps.asignadas }}/{{ cliente.infoCliente.infoApps.totalApps }}
                                            </span>
                                        </div>
                                        <!--<div><span class="font-weight-bold">Usuarios Hab.: </span> {{ cliente.infoCliente.infoUsuarios.habilitados }}</div>
                                        <div><span class="font-weight-bold">Usuarios deshab.: </span> {{ cliente.infoCliente.infoUsuarios.deshabilitados }}</div>-->
                                    
                                        
                                        <!--<div><span class="font-weight-bold">Apps Asignadas: </span> {{ cliente.infoCliente.infoApps.asignadas }}</div>

                                        <CRow v-bind:key="appDetalle.nombreApp" v-for="appDetalle in cliente.infoCliente.infoApps.detallesAppsAsigandas">
                                            <CCol>({{ appDetalle.total }}){{ appDetalle.nombreApp }}</CCol>
                                        </CRow>-->

                                    </CCol>
                                    <CCol col="3">
                                        <div>
                                            <span class="font-weight-bold">Almacenamiento: </span> 
                                                <span
                                                    content="Usado / Disponible / Total"                                            
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }">
                                                1 Gb / 2 Gb / 3 Gb
                                            </span>
                                        </div>
                                        <div>
                                            <span class="font-weight-bold">Documentos: </span>
                                            <div>
                                                <span class="text-center mb-3" v-if="cliente.cliB2BMail == null">No hay Cliente asociado en Mail</span>
                                                <span class="text-center mb-3" v-else>
                                                    <span sm="12" md="12" lg="12" v-if="cliente.cliB2BMail.length<=0"><center>No hay documentos asociados para este cliente</center></span>
                                                    <span v-else v-bind:key="documento.idDocumento" v-for="(documento, i) in cliente.cliB2BMail.documentos">
                                                        <span>({{ documento.codigoDocumento }}
                                                            <a 
                                                                v-if="documento.idArchivoDrive != null"
                                                                :href="documento.urlDescarga" 
                                                                target="_blank" 
                                                                :style="{'color': (documento.nula?'red':'green')}"
                                                                style="text-decoration: none;" 
                                                                :content="getTextoDocumento(documento)"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                            >
                                                                <CIcon :content="$options.freeSet.cilCloudDownload" />                               
                                                            </a>
                                                            <a
                                                                v-else
                                                                size="sm" variant="ghost"
                                                                content="Sin Archivo"
                                                                    v-tippy="{ 
                                                                        placement: 'top',
                                                                        arrow: true, 
                                                                        arrowType: 'round', 
                                                                        animation:'fade',
                                                                        theme: 'google',
                                                                        followCursor : true,
                                                                    }"
                                                                >
                                                                <CIcon
                                                                    :content="$options.freeSet.cilMeh"
                                                                />
                                                            </a>)
                                                        </span>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </CCol>
                                    <CCol col="3">
                                        <div>
                                            <span class="font-weight-bold">Complementos: </span> 
                                            <span
                                                content="Revisando que hacer"                                            
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }">
                                                En Revision
                                            </span>
                                        </div>
                                    </CCol>
                                </CRow>
                            </CCardHeader>
                            <CCollapse :show="cliente.acciones.mostrarMas" :duration="400">
                                <CCardBody style="background-color: #F5F5F5;">
                                    <CTabs :active-tab.sync="actTab">
                                        <CTab>
                                            <template slot="title">
                                                Información Cliente
                                            </template>
                                            
                                            <InfoCliente :informacionCliente="cliente.infoCliente" :informacionB2BMail="cliente.cliB2BMail" />
                                        </CTab>
                                        <CTab>
                                            <template slot="title">
                                                Usuarios
                                            </template>
                                            <UsuariosCliente :usuarios="cliente.usuarios" :accionesCliente="cliente.acciones" :infoCliente="cliente.infoCliente" />
                                            
                                        </CTab>
                                    </CTabs>
                    
                                    
                                </CCardBody>
                            </CCollapse>
                        </CCard>
                    </CCol>
                </CRow>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import cons from "@/const";
    import axios from "axios";

    import Multiselect from "vue-multiselect";

    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";

    import { freeSet } from "@coreui/icons";

    //import moment from 'moment'
    import { format, formatDistance, formatRelative, isThisISOWeek, subDays } from "date-fns";
    import es from "date-fns/locale/es";
    window.locale = "es";

    import DatosGeneralClientes from './DatosGeneralClientes'
    import InfoCliente from "./InfoCliente";
    import UsuariosCliente from "./UsuariosCliente";
    //import UsuariosClienteVapp from "./UsuariosClienteVapp";


    //import DatePicker from 'vue2-datepicker';
    //import 'vue2-datepicker/index.css';

    import Pagination from 'vue-pagination-2';

    export default {
        name: "ClientesVapp",
        freeSet,
        components: {
            Multiselect,
            Modal: VueModal,
            Pagination,
            InfoCliente,
            //UsuariosClienteVapp,
            DatosGeneralClientes,
            UsuariosCliente
        },
        data() {
            return {
                paginaActual: 1,

                baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,

                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,

                isLoadingEmpresas: false,
                
                actTab: 0,
                clientesVapp: [],
                datosGeneral: {},
                busquedaCliente: "",
                verDeshabilitados: false,
                datosPaginacion: null,
            };
        },
        created: function () {},
        beforeMount() {
            //this.getInfoGeneralClientesVapp()
            this.getClientesVapp()
        },
        mounted() {},
        methods: {
            obtenerLargoPaginacion: function(total){
                if(Object.keys(this.datosGeneral).length > 0){
                    return parseInt(total/10)+1
                } else {
                    return 1
                }
            },
            prueba: function(){
                console.log("aqui", this.page)
                this.getClientesVapp()
            },
            salioAlOver: function(cliente){
                cliente.acciones.focus = false;
                console.log("salio")
            },
            entroAlOver: function(cliente){
                cliente.acciones.focus = true;
                console.log("entro")
            },
            getInfoGeneralClientesVapp: function(){
                
                let url = this.baseUrl + "/get_info_general_clientes_vapp";
                axios({
                    method: "POST",
                    url: url,
                    headers: {
                        Authorization: this.tokenLogin,
                    },
                })
                    .then((result) => {
                        console.log("resp", result)
                    },
                    (error) => {})
                    .finally(() => {
                    });
            },
            getClientesVapp: function(){
                this.isLoadingEmpresas = true
                let url = this.baseUrl + "/get_clientes_vappe";
                axios({
                    method: "POST",
                    url: url,
                    data: {
                        //"filtroCliente": this.filtrosClientesVappEdig,
                        //"filtroTexto": this.filtroGeneralCliente,
                        "filtro": {
                            "textoFiltro": this.busquedaCliente.replace(".","")
                        },
                        "paginacion": {
                            "paginacion": true,
                            "actual": this.paginaActual,
                            "tamanioPagina": 10,
                            "ultimoCliente": this.datosPaginacion != null ? this.datosPaginacion.ultimoCliente : null
                        }
                    },
                    headers: {
                        Authorization: this.tokenLogin,
                    },
                })
                    .then((result) => {
                        this.clientesVapp = result.data.infoClientes.clientes
                        this.datosGeneral = result.data.infoClientes.datosGeneral
                        this.datosPaginacion = result.data.infoClientes.datosPaginacion
                        
                        //this.isLoadingEmpresas = false
                    },
                    (error) => {
                        //this.isLoadingEmpresas = false
                    }
                    )
                    .finally(() => {
                        this.isLoadingEmpresas = false
                    });
                
            },


            filtrarClientes: function (clientes){
                let clientesProce = clientes
                if(this.verDeshabilitados){
                    clientesProce = clientes.filter(cli => cli.habilitado == false)
                }
                return this.$vs.getSearch(clientesProce, this.busquedaCliente.replace(".",""))
            },
            getTextoDocumento: function(documento){
                return `<div>Descargar Documento</div> 
                <div>(${documento.tipoDocCliente})</div>`

            }


        },
    };
</script>

<style>

.cardHabil{
    border-color: green;
}
.cardDeshab{
    border-color: red;
}

</style>